<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Relatórios</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Relatórios</div>
        </div>
        <button class="appui-btn appui-btn--ghost" @click="reload()"><i class="mdi mdi-refresh mr-1"></i> Atualizar</button>
      </div>

      <!-- Métricas consolidadas -->
      <section class="appui-card appui-card--flush" style="margin-bottom:20px">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left"><span class="appui-sec-title">Engajamento consolidado</span></div>
        </div>
        <div class="appui-stat-grid">
          <div v-for="m in cards" :key="m.key" class="appui-stat">
            <span class="appui-stat-icon"><i :class="m.icon"></i></span>
            <div>
              <div class="appui-stat-value">{{ summary[m.key] != null ? summary[m.key] : '—' }}</div>
              <div class="appui-stat-label">{{ m.label }}</div>
            </div>
          </div>
        </div>
      </section>

      <!-- Exportações -->
      <section class="appui-card" style="padding:22px 24px">
        <h2 class="appui-sec-title">Exportações</h2>
        <p class="appui-sec-sub">Planilhas em Excel para prestação de contas.</p>
        <div style="display:flex;gap:10px;flex-wrap:wrap">
          <button class="appui-btn appui-btn--ghost" @click="download('ranking')"><i class="mdi mdi-download mr-1"></i> Ranking da gamificação</button>
          <button class="appui-btn appui-btn--ghost" @click="download('survey')"><i class="mdi mdi-download mr-1"></i> Respostas da pesquisa</button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { errorMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

export default {
  components: {},
  name: 'app-reports',
  data () {
    return {
      summary: {},
      cards: [
        { key: 'participants', label: 'Participantes', icon: 'bx bx-user' },
        { key: 'gamification_points', label: 'Pontos distribuídos', icon: 'bx bx-medal' },
        { key: 'feed_posts', label: 'Posts no feed', icon: 'bx bx-news' },
        { key: 'feed_comments', label: 'Comentários', icon: 'bx bx-comment' },
        { key: 'feed_likes', label: 'Curtidas', icon: 'bx bx-heart' },
        { key: 'room_askings', label: 'Perguntas (salas)', icon: 'bx bx-help-circle' },
        { key: 'poll_votes', label: 'Votos em enquetes', icon: 'bx bx-bar-chart-square' },
        { key: 'quiz_answers', label: 'Respostas de quiz', icon: 'bx bx-check-square' },
        { key: 'word_cloud', label: 'Palavras (nuvem)', icon: 'bx bx-cloud' },
        { key: 'store_orders', label: 'Pedidos na loja', icon: 'bx bx-package' },
        { key: 'survey_replies', label: 'Respostas da pesquisa', icon: 'bx bx-list-check' },
        { key: 'certificates', label: 'Certificados', icon: 'bx bx-certification' },
        { key: 'connections', label: 'Conexões', icon: 'bx bx-network-chart' },
        { key: 'indications', label: 'Indicações', icon: 'bx bx-user-plus' }
      ]
    }
  },
  mounted () { this.reload() },
  methods: {
    reload () { services.metricsSummary().then(r => { this.summary = r.data.data }).catch(() => errorMessage('Falha ao carregar métricas.', 3000)) },
    async download (which) {
      const loader = this.$loading.show()
      try {
        const res = which === 'ranking' ? await services.exportRanking() : await services.exportSurvey()
        const url = URL.createObjectURL(new Blob([res.data]))
        const a = document.createElement('a')
        a.href = url
        a.download = which === 'ranking' ? 'ranking-gamificacao.xlsx' : 'pesquisa-satisfacao.xlsx'
        a.click()
        URL.revokeObjectURL(url)
      } catch (e) { errorMessage('Falha ao exportar.', 3000) } finally { loader.hide() }
    }
  }
}
</script>
